/* eslint-disable  no-restricted-globals */

import ClickAwayListener from '@material-ui/core/ClickAwayListener'
import Menu from '@material-ui/core/Menu'
import React from 'react'
import styled, { ThemeProvider } from 'styled-components'

import theme from '../../utils/theme'
import ActionButton from '../Button/ActionButton'
import Icon from '../Icon'

const Nav = styled.nav`
  display: flex;
  flex-direction: column;
  .MuiListItem-root {
    font-size: ${props => props.theme.typography.fontSizeSm};
  }
`

// biome-ignore lint/correctness/noUnusedFunctionParameters: TODO
const RowActionMenu = ({ children, className, disabled, isMobile, label, white }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = event => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = event => {
    event.stopPropagation()
    setAnchorEl(null)
  }

  return (
    <ThemeProvider theme={theme}>
      <ClickAwayListener onClickAway={handleClose}>
        {/** biome-ignore lint/complexity/noUselessFragments: TODO */}
        <>
          {children.length === 0 ? null : (
            <ActionButton
              className="rowActionItem"
              onClick={handleClick}
              onFocus={event => event.stopPropagation()}
              tabIndex="-1"
              disabled={disabled || !children}
              white={white}
              iconOnly
            >
              <Icon iconName="threeDots" iconSize={24} className="three-dots-icon" alt={label} />
            </ActionButton>
          )}
          {open && (
            <Menu anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
              <Nav className={className} onClick={handleClose}>
                {children}
              </Nav>
            </Menu>
          )}
        </>
      </ClickAwayListener>
    </ThemeProvider>
  )
}

RowActionMenu.defaultProps = {
  label: 'Actions',
  white: false,
}

export default RowActionMenu
